exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-component='new-user-confirmation'] {\n  margin: 50px 0 0;\n}\n[data-component='new-user-confirmation'] .buttons {\n  text-align: center;\n}\n[data-component='new-user-confirmation'] .buttons .btn {\n  width: 200px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/user-admin/new-user-confirmation/new-user-confirmation.component.styl
// module id = ../../../../../src/app/master/user-admin/new-user-confirmation/new-user-confirmation.component.styl
// module chunks = main